module.exports = __webpack_public_path__ + "static/media/hew.892a0016.svg";